import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import { useSelector } from 'react-redux';

function AddEditReferralFacilityPopup({
  onClose,
  typeState,
  onReload,
  editPopup,
  setEditPopup,
}) {
  const { user } = useSelector((store) => store.auth);

  const [data, setData] = useState('');

  // Local formData state
  const [formData, setFormData] = useState({
    id: '',
    facility_name: '',
    Specialty: '',
    address_1: '',
    city: '',
    state: '',
    zip: '',
    email: '',
    phone_l: '',
    phone_m: '',
    fax: '',
    note: '',
  });

  useEffect(() => {
    (async () => {
      try {
        let type;
        if (typeState === 3) type = 'facility';
        else if (typeState === 5) type = 'otherFacility';
        const response = await post('api/commonTask/openAddEditMasterPopup', {
          facilityId: editPopup?.referringMasterId,
          popUpType: type,
        });
        if (response.status === 200) {
          setData(response.data);
          setFormData({
            id: response.data.facilityMaster[0]?.id || '',
            facility_name: response.data.facilityMaster[0]?.facility_name || '',
            Specialty: response.data.facilityMaster[0]?.Specialty || '',
            address_1: response.data.facilityMaster[0]?.address_1 || '',
            city: response.data.facilityMaster[0]?.city || '',
            state: response.data.facilityMaster[0]?.state || '',
            zip: response.data.facilityMaster[0]?.zip || '',
            email: response.data.facilityMaster[0]?.email || '',
            phone_l: response.data.facilityMaster[0]?.phone_l || '',
            phone_m: response.data.facilityMaster[0]?.phone_m || '',
            fax: response.data.facilityMaster[0]?.fax || '',
            note: response.data.facilityMaster[0]?.note || '',
          });
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [editPopup, typeState]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSaveUpdate = async () => {
    try {
      if (!formData?.facility_name) {
        setUiMessage('err', 'Please enter Facility Name');
      } else if (typeState === 5 && !formData?.Specialty) {
        setUiMessage('err', 'Please enter Type');
      } else if (typeState === 5 && !formData?.address_1) {
        setUiMessage('err', 'Please enter Address');
      } else if (typeState === 5 && !formData?.city) {
        setUiMessage('err', 'Please enter City');
      } else if (typeState === 5 && !formData?.state) {
        setUiMessage('err', 'Please enter State');
      } else if (typeState === 5 && !formData?.zip) {
        setUiMessage('err', 'Please enter Zip code');
      } else if (typeState === 5 && !formData?.email) {
        setUiMessage('err', 'Please enter Email');
      } else if (typeState === 5 && !formData?.phone_l) {
        setUiMessage('err', 'Please enter Desk phone');
      } else if (typeState === 5 && !formData?.fax) {
        setUiMessage('err', 'Please enter Fax');
      } else {
        let facilityType;
        if (typeState === 3) facilityType = '1';
        else if (typeState === 5) facilityType = '4';
        const response = await post('api/commonTask/saveUpdateFacilityMaster', {
          userId: user?.id,
          facilityId: editPopup?.referringMasterId || '',
          facilityType: facilityType,
          ...formData,
        });
        if (response.status === 200) {
          setUiMessage('suc', 'Facility Added Successfully.');
          onReload();
          onClose();
        }
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="openReferringProviderPopup">
        <div className="addressBookHeader">
          <span className="addressTitle">
            <h2>
              {/* Update Facility */}
              {typeState === 3 && 'Update Facility'}
              {typeState === 5 && 'Update Recipient'}
            </h2>
          </span>

          <span className="addressClose" onClick={onClose}>
            X
          </span>
        </div>

        <div className="addressBody">
          {/* First Row */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Facility Name *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="facility_name"
                  value={formData.facility_name}
                  placeholder="Facility Name"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Type/Specialty</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="Specialty"
                  value={formData.Specialty}
                  placeholder="eg, General Hospital, Imaging Center"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="addressBodyRow">Street Address</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh"
              type="text"
              name="address_1"
              value={formData.address_1}
              placeholder="Street Address"
              onChange={handleChange}
            />
          </div>

          {/* City / State / Zip */}
          <div className="addressBodyRow">
            {/* City */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">City</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="city"
                  value={formData.city}
                  placeholder="City"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            {/* State */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">State</div>
              <div className="addressBodyRow">
                <select
                  id="facilityState"
                  className="chzn-select addressBookSearh"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {data?.stateMaster?.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.stateName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            {/* Zip */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">ZIP Code</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="zip"
                  value={formData.zip}
                  placeholder="Zip"
                  maxLength="5"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="addressBodyRow">Email</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh"
              type="text"
              name="email"
              value={formData.email}
              placeholder="Email address"
              onChange={handleChange}
            />
          </div>

          {/* Phones */}
          <div className="addressBodyRow">
            {/* Desk Phone */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Desk Phone</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="phone_l"
                  value={formData.phone_l}
                  placeholder="Main phone number"
                  maxLength="10"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            {/* Cell */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Cell Phone</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="phone_m"
                  value={formData.phone_m}
                  placeholder="Mobile number"
                  maxLength="10"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            {/* Fax */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Fax</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="fax"
                  value={formData.fax}
                  placeholder="Fax number"
                  maxLength="10"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Note */}
          <div className="addressBodyRow">Note</div>
          <div className="addressBodyRow">
            <textarea
              className="addressBookSearh"
              name="note"
              placeholder="Additional notes or special instructions"
              rows="3"
              value={formData.note}
              onChange={handleChange}
            ></textarea>
          </div>

          {/* Buttons */}
          <div className="addressBodyRow">
            <div
              style={{ marginLeft: '10px' }}
              className="button-submit right"
              onClick={() => {
                // onUpdate(formData.id, formData)
                onSaveUpdate();
              }}
            >
              {editPopup?.referringMasterId ? 'Update' : 'Save'}
            </div>

            <div className="button-submit right" onClick={onClose}>
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddEditReferralFacilityPopup;
